export default __webpack_public_path__ + "static/media/vaeb.04767882.png";